module.exports = __webpack_public_path__ + "static/media/melvin_faculty.619c3c38.jpg";